import axios from "axios";
import { priceChangeSearchUrl, priceChangeUrl } from "../../Config/Url";

export const priceChangeService = {
  documentSearch,
  documentDelete,
  documentCreate,
  documentLock,
  getDocumentById,
  documentUpdate,
  documentDetails,
};

async function documentSearch(
  tenantId,
  pageIndex,
  pageSize,
  sortName,
  isAsc,
  storeId,
  searchText,
  dateFrom,
  dateTo
) {
  return axios
    .put(priceChangeSearchUrl, {
      tenantId,
      pageIndex,
      pageSize,
      sortName,
      isAsc,
      storeId,
      searchText,
      dateFrom,
      dateTo,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentDelete(documentGuid) {
  return axios
    .delete(`${priceChangeUrl}/${documentGuid}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentCreate(
  documentDate,
  storeId,
  note,
  startDate,
  endDate,
  products
) {
  let items = products.map((item) => ({
    productGuid: item.productGuid,
    oldPrice: item.price,
    newPrice: Number(
      item.price2.includes(",") ? item.price2.replace(/,/g, ".") : item.price2
    ),
  }));

  return axios
    .post(priceChangeUrl, {
      storeId,
      documentDate,
      startDate,
      endDate,
      note,
      items,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentLock(documentGuid) {
  return axios
    .patch(`${priceChangeUrl}/${documentGuid}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function getDocumentById(documentGuid) {
  return axios
    .get(`${priceChangeUrl}/${documentGuid}`)
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentUpdate(
  priceChangeGuid,
  storeId,
  documentDate,
  startDate,
  endDate,
  note,
  products
) {
  let items = products.map((item) => ({
    priceChangeDetailGuid: item.priceChangeDetailGuid
      ? item.priceChangeDetailGuid
      : null,
    productGuid: item.productGuid,
    oldPrice: item.oldPrice,
    newPrice: Number(
      typeof item.newPrice == "string" && item.newPrice.includes(",")
        ? item.newPrice.replace(/,/g, ".")
        : item.newPrice
    ),
    isActive: item.isActive,
  }));

  return axios
    .put(`${priceChangeUrl}/${priceChangeGuid}`, {
      storeId: Number(storeId),
      documentDate,
      startDate,
      endDate,
      note,
      items,
    })
    .then((res) => res)
    .catch((err) => err.response);
}

async function documentDetails(priceChangeGuid) {
  return axios
    .get(`${priceChangeUrl}/${priceChangeGuid}/details`)
    .then((res) => res)
    .catch((err) => err.response);
}
